import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {ChartModule} from 'primeng/chart';
import {MessageModule} from 'primeng/message';
import {SkeletonModule} from 'primeng/skeleton';

import {SharedModule} from '../../shared/shared.module';
import {StatisticsCategoryTableComponent} from './components/statistics-category-table/statistics-category-table.component';
import {StatisticsDataQualityComponent} from './components/statistics-data-quality/statistics-data-quality.component';
import {StatisticsOverviewComponent} from './components/statistics-overview/statistics-overview.component';
import {StatisticsPageComponent} from './components/statistics-page/statistics-page.component';
import {StatisticsReportComponent} from './components/statistics-report/statistics-report.component';
import {StatisticsCountPipe} from './pipes/statistics-count.pipe';

@NgModule({
  imports: [
    SharedModule,
    RouterModule,
    ChartModule,
    MessageModule,
    SkeletonModule
  ],
  declarations: [
    StatisticsPageComponent,
    StatisticsOverviewComponent,
    StatisticsCategoryTableComponent,
    StatisticsDataQualityComponent,
    StatisticsReportComponent,
    StatisticsCountPipe
  ],
  exports: [
    StatisticsPageComponent
  ]
})
export class StatisticsModule {
}
